import React from "react";
import {
	  Container,
	  Typography,
	  Paper,
	  List,
	  ListItem,
	  ListItemText,
	  Chip,
	  Box,
	  Divider
} from "@mui/material";

const items = [
	  "Prioritization of Scenarios & Situations",
	  "Behaviors of Excellence",
	  "Legal, HIPAA, Security, Accessibility, ++",
	  "Caregiving Skill Growth Path",
	  "Employee & other Roles to train",
	  "Analytics of interest",
	  "Integration w/ existing training",
	  "Multi-modal",
	  "Prioritization of training prior to practice",
	  "Usage assisting hiring decisions",
	  "Certifications",
	  "Languages (English, Spanish, ++)",
	  "LMS",
	  "Structure & nature of feedback given",
	  "Clinician Training by Example",
	  "Standby agents to support Caregivers that are using our training",
	  "Best mix of humans training by example and demonstrating good/bad on video and targeted AI Avatars",
	  "Incorporation of best practices from SWA, Boeing and additional Advanced Simulations",
	  "Bigger Picture win-wins",
	  "Approach to Pilot",
	  "Goals, Schedule, Responsibilities, Team, ++"
];

export default function PrettyList() {
	  return (
		      <Container maxWidth="md" sx={{ mt: 6 }}>
		        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
		          <Typography variant="h5" align="center" gutterBottom>
		            Lots to Talk About Together!
		          </Typography>
		          <List>
		            {items.map((item, index) => (
				                <React.Fragment key={index}>
				                  <ListItem alignItems="flex-start" sx={{ py: 1.5 }}>
				                    <Chip
				                      label={`#${index + 1}`}
				                      color="primary"
				                      size="small"
				                      sx={{ mr: 2 }}
				                    />
				                    <ListItemText primary={item} />
				                  </ListItem>
				                  {index < items.length - 1 && <Divider />}
				                </React.Fragment>
				              ))}
		          </List>
		        </Paper>
		      </Container>
		    );
}

